import { render, staticRenderFns } from "./szhzxCase.vue?vue&type=template&id=83789ec6&scoped=true"
import script from "./szhzxCase.vue?vue&type=script&lang=js"
export * from "./szhzxCase.vue?vue&type=script&lang=js"
import style0 from "./szhzxCase.vue?vue&type=style&index=0&id=83789ec6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83789ec6",
  null
  
)

export default component.exports